import { filtersSlugToParams } from '@core/Services/Search/Utils/FiltersSlugToParams';
import { mergeSlugAndSearchParams } from '@core/Services/Search/Utils/MergeSlugAndSearchParams';
import { getRootFromPath } from '@core/Utils/Search/GetRootFromPath';

export const getPlpPath = async (newUrl: string, validateUrl: any) => {
  const url = new URL(`${location.origin}${newUrl}`);

  const searchParams = urlParamsToRecord(url.searchParams);

  const filtersSlug = url.pathname.split('/').slice(1);

  const root = getRootFromPath(url.pathname);

  const slugParams = await filtersSlugToParams(filtersSlug, root);

  const combinedParams = mergeSlugAndSearchParams(slugParams, searchParams ?? {});

  const { alternativePath } = validateUrl([], searchParams, combinedParams, 'used');

  return alternativePath;
};

function urlParamsToRecord(searchParams: URLSearchParams) {
  const result: any = {};
  // @ts-expect-error - needs downlevelIteration flag
  for (const key of searchParams.keys()) {
    const values = searchParams.getAll(key);
    result[key] = values.length > 1 ? values : values[0];
  }
  return result;
}
